import { Injectable } from '@angular/core';
import AgoraRTC from "agora-rtc-sdk-ng"

@Injectable({
  providedIn: 'root'
})
export class AgoraSdkConfigService {
  options =
    {
      // Pass your App ID here.
      appId: '',
      // Set the channel name.
      channel: '',
      // Pass your temp token here.
      token: '',
      // Set the user ID.
      uid: 0,
    };

  channelParameters =
    {
      // A variable to hold a local audio track.
      localAudioTrack: null,
      // A variable to hold a local video track.
      localVideoTrack: null,
      // A variable to hold a remote audio track.
      remoteAudioTrack: null,
      // A variable to hold a remote video track.
      remoteVideoTrack: null,
      // A variable to hold the remote user id.s
      remoteUid: null,
    };
  constructor() { }
}
